import { render, staticRenderFns } from "./DesignPalette.vue?vue&type=template&id=4bba4a56&scoped=true"
import script from "./DesignPalette.vue?vue&type=script&lang=js"
export * from "./DesignPalette.vue?vue&type=script&lang=js"
import style0 from "./DesignPalette.vue?vue&type=style&index=0&id=4bba4a56&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bba4a56",
  null
  
)

export default component.exports